export interface Addon {
  id: string;
  name: string;
}